/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type OfficeHours = { day: Day; startMinute: number; endMinute: number };

export type Day =
  | 'MON_FRI'
  | 'SAT_SUN'
  | 'EVERY_DAY'
  | 'SUNDAY'
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | unhandledEnumCase;

export type AgentToneResponse = { useFormalTone: boolean };

export type AgentVisibilityFilter = 'ALL' | 'VISIBLE_ONLY' | unhandledEnumCase;

export type AiAgentCreateRequest = {
  createdWithGuidelines: Default<boolean>;
  name: string;
  businessUnitId: Default<number>;
  role: Default<Role>;
  personality: Default<Personality>;
  agentType: Default<AgentType>;
  voice: Default<OpenAiRealtimeVoice>;
  configuredLanguages: Default<string[]>;
  filterCitationLanguage: Default<boolean>;
};

export type AiAgentHydratedData = {
  aiAgentUserId: number;
  aiAgentVersionId: Default<number>;
  hasDataSources: boolean;
  hasActiveDataSources: boolean;
  aiChannelInstanceRoutingRule: Default<AiChannelInstanceRoutingRule[]>;
};

export type AiAgentHydratedResponse = {
  aiAgentUserId?: number;
  aiAgentVersionId: Default<number>;
  hasDataSources: boolean;
  hasActiveDataSources: boolean;
  aiChannelInstanceRoutingRule: Default<AiChannelInstanceRoutingRule[]>;
};

export type AiAgentHydratedResponseV2 = {
  aiAgentHydratedData: Default<AiAgentHydratedData[]>;
};

export type AiAgentIdResponse = {
  aiAgentUserId: number;
  aiAgentVersionId: Default<number>;
};

export type AiAgentPortalPagedRequest = {
  offset: Default<number>;
  deletedFilter: Default<DeletedFilter>;
  visibilityFilter: Default<AgentVisibilityFilter>;
  pageLength: Default<number>;
};

export type AiAgentPortalPagedResponse = {
  results: Default<AiAgentRow[]>;
  hasMore: boolean;
  offset: number;
};

export type AiAgentProfilePortalPagedRequest = {
  offset: Default<number>;
  agentTypeFilter: Default<AgentType[]>;
  pageLength: Default<number>;
};

export type AiAgentProfilePortalPagedResponse = {
  defaultAgent?: AiAgentProfileResponse;
  isMultiAgentWithoutBrandsEnabled: Default<boolean>;
  multiAgentWithoutBrandsLimit?: number;
  results: Default<AiAgentProfileResponse[]>;
  hasMore: boolean;
  offset: number;
};

export type AiAgentProfileResponse = {
  name: string;
  avatarUri: string;
  personalityInstruction: Default<PersonalityInstructions>;
  disabledReason?: DisabledReason;
  createdWithGuidelines: Default<boolean>;
  userId: number;
  portalId: number;
  emailAddress: string;
  role: Role;
  personality: Personality;
  agentType: Default<AgentType>;
  voice?: OpenAiRealtimeVoice;
  createdAt: Default<number>;
  createdByUserId?: number;
  deletedAt: Default<number>;
  businessUnitId: Default<number>;
  isGovernanceEnabled: Default<boolean>;
  isVoiceGovernanceEnabled: Default<boolean>;
  isAiAccessEnabled: Default<boolean>;
  hasScopeAccess: Default<boolean>;
  configuredLanguages: Default<string[]>;
  filterCitationLanguage: Default<boolean>;
};

export type AiAgentResponse = {
  disabledReason?: DisabledReason;
  userId: number;
  portalId: number;
  emailAddress: string;
  role: Role;
  personality: Personality;
  agentType: Default<AgentType>;
  voice?: OpenAiRealtimeVoice;
  createdAt: Default<number>;
  createdByUserId?: number;
  deletedAt: Default<number>;
  businessUnitId: Default<number>;
  isGovernanceEnabled: Default<boolean>;
  isVoiceGovernanceEnabled: Default<boolean>;
  isAiAccessEnabled: Default<boolean>;
  hasScopeAccess: Default<boolean>;
  configuredLanguages: Default<string[]>;
  filterCitationLanguage: Default<boolean>;
};

export type AiAgentRow = {
  userId: number;
  portalId: number;
  emailAddress: string;
  role: Role;
  personality: Personality;
  agentType: Default<AgentType>;
  voice?: OpenAiRealtimeVoice;
  createdAt: Default<number>;
  createdByUserId?: number;
  deletedAt: Default<number>;
  businessUnitId: Default<number>;
  isGovernanceEnabled: Default<boolean>;
  isVoiceGovernanceEnabled: Default<boolean>;
  isAiAccessEnabled: Default<boolean>;
  hasScopeAccess: Default<boolean>;
  configuredLanguages: Default<string[]>;
  filterCitationLanguage: Default<boolean>;
};

export type AiAgentUpdateProfileRequest = {
  name?: string;
  role?: Role;
  personality?: Personality;
  avatarFileId?: number;
  voice?: OpenAiRealtimeVoice;
  configuredLanguages?: string[];
  filterCitationLanguage?: boolean;
  businessUnitId?: number;
  aiAgentUserId: number;
  aiAgentVersionId: Default<number>;
};

export type AiChannelInstanceRoutingRule = {
  channelInstanceId: number;
  genericChannelId: number;
  routingRule: RoutingRule;
};

export type DeleteAiAgentRequest = {
  aiAgentUserId: number;
  aiAgentVersionId: Default<number>;
};

export type DisabledReason =
  | 'OUT_OF_CREDITS'
  | 'MANUAL_PAUSE'
  | unhandledEnumCase;

export type GetAiAgentByUserIdResponse = {
  aiAgentResponseMaybe?: AiAgentResponse;
};

export type GetAiAgentOrThrowIfMultipleResponse = {
  aiAgentResponseMaybe?: AiAgentResponse;
};

export type GetAiAgentRequest = {
  aiAgentUserId: number;
  aiAgentVersionId: Default<number>;
};

export type IsMaintenanceModeEnabledResponse = {
  isMaintenanceModeEnabled: boolean;
};

export type Personality =
  | 'FRIENDLY'
  | 'PROFESSIONAL'
  | 'CASUAL'
  | 'EMPATHETIC'
  | 'WITTY'
  | 'BRAND_VOICE'
  | unhandledEnumCase;

export type PersonalityInstructions = {
  name: string;
  personality: Personality;
  instructions: string;
};

export type RestoreAiAgentRequest = {
  aiAgentUserId: number;
  aiAgentVersionId: Default<number>;
};

export type Role =
  | 'CUSTOMER_SUPPORT'
  | 'MARKETING_SPECIALIST'
  | 'SALES_REPRESENTATIVE'
  | unhandledEnumCase;

export type ValidateAgentNameRequest = {
  name: string;
  aiAgentUserId?: number;
  aiAgentVersionId: Default<number>;
};

export type ValidateAgentNameResponse = {
  valid: boolean;
  errorType?: ErrorType;
};

export type AiAgentError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'MISSING_REQUIRED_FIELDS'
  | 'AGENT_NOT_FOUND'
  | 'AGENT_ALREADY_EXISTS_FOR_PORTAL'
  | 'AI_ACCESS_CONTROLS_DISABLED'
  | 'AGENT_USER_NOT_FOUND'
  | 'AGENT_AVATAR_FILE_NOT_FOUND'
  | 'AGENT_AVATAR_FILE_UPLOAD_FAILED'
  | 'MULTIPLE_AGENTS_FOUND'
  | 'BRAND_VOICE_NOT_AVAILABLE'
  | 'AGENT_IS_DELETED'
  | 'GOVERNANCE_CHECK_FAILED'
  | 'INVALID_AGENT_NAME'
  | 'BLANK_AGENT_NAME'
  | 'AGENT_NAME_TOO_LONG'
  | 'INVALID_AGENT_NAME_FORMAT'
  | 'PORTAL_IS_NOT_IN_CURRENT_HUBLET'
  | 'CUSTOMER_AGENT_ROW_ACCESS_DENIED'
  | 'SOX_AUDIT_VALIDATION_FAILED'
  | 'BUSINESS_UNIT_NOT_FOUND'
  | 'DUPLICATE_AGENT_NAME'
  | 'AGENT_ALREADY_EXISTS_FOR_BUSINESS_UNIT'
  | 'INVALID_DEPLOYMENT_CHANGE_TYPE'
  | 'AGENT_LIMIT_REACHED'
  | 'UNSUPPORTED_OBJECT_TYPE'
  | 'OBJECT_NOT_FOUND'
  | 'ASSIGNMENT_FAILED'
  | 'AGENT_TYPE_NOT_ALLOWED'
  | unhandledEnumCase;

export type VoidResponse = {};

export type RoutingRule = {
  id: number;
  portalId: number;
  ruleDefinition: RoutingRuleDefinition;
};

export const RoutingRuleDefinitionDiscriminantKey = '@type';
export type RoutingRuleDefinition =
  | UnassignedRouting
  | UsersAndTeamsRouting
  | InboxUsersRouting
  | BotRouting
  | OwnerRouting
  | QuoteOwnerRouting
  | SkillRouting
  | AiChatbotRouting
  | TeamsOnlyRouting
  | WaitlistRouting
  | CustomerAgentRouting
  | SpecifiedHoursRouting
  | CustomerAgentComplexRouting
  | SkillBasedRouting
  | WorkflowRouting;

export type RuleWithPercentage = {
  rule: RoutingRuleDefinition;
  percentage: number;
};

export const AiChatbotRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.AiChatbotRouting';
export const AiChatbotRoutingDiscriminant = 'AI_CHATBOT';
export const AiChatbotRoutingDiscriminantKey = '@type';
export type AiChatbotRouting = {
  aiChatbotId: number;
  fallback: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.AiChatbotRouting';
} & { '@type'?: 'AI_CHATBOT' };

export const BotRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.BotRouting';
export const BotRoutingDiscriminant = 'BOT';
export const BotRoutingDiscriminantKey = '@type';
export type BotRouting = {
  botId: number;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.BotRouting';
} & { '@type'?: 'BOT' };

export const CustomerAgentComplexRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.CustomerAgentComplexRouting';
export const CustomerAgentComplexRoutingDiscriminant = 'CUSTOMER_AGENT_COMPLEX';
export const CustomerAgentComplexRoutingDiscriminantKey = '@type';
export type CustomerAgentComplexRouting = {
  timezoneId?: string;
  hoursByRule: Default<RuleWithHours[]>;
  percentageByRule: Default<RuleWithPercentage[]>;
  defaultRule: RoutingRuleDefinition;
  targeting?: DeploymentTarget;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.CustomerAgentComplexRouting';
} & { '@type'?: 'CUSTOMER_AGENT_COMPLEX' };

export const CustomerAgentRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.CustomerAgentRouting';
export const CustomerAgentRoutingDiscriminant = 'CUSTOMER_AGENT';
export const CustomerAgentRoutingDiscriminantKey = '@type';
export type CustomerAgentRouting = {
  aiAgentId: number;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.CustomerAgentRouting';
} & { '@type'?: 'CUSTOMER_AGENT' };

export type Distribution =
  | 'RANDOM'
  | 'BALANCED'
  | 'ROUND_ROBIN'
  | unhandledEnumCase;

export const InboxUsersRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.InboxUsersRouting';
export const InboxUsersRoutingDiscriminant = 'INBOX_USERS';
export const InboxUsersRoutingDiscriminantKey = '@type';
export type InboxUsersRouting = {
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.InboxUsersRouting';
} & { '@type'?: 'INBOX_USERS' };

export const OwnerRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.OwnerRouting';
export const OwnerRoutingDiscriminant = 'OWNER';
export const OwnerRoutingDiscriminantKey = '@type';
export type OwnerRouting = {
  fallback: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.OwnerRouting';
} & { '@type'?: 'OWNER' };

export const QuoteOwnerRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.QuoteOwnerRouting';
export const QuoteOwnerRoutingDiscriminant = 'QUOTE_OWNER';
export const QuoteOwnerRoutingDiscriminantKey = '@type';
export type QuoteOwnerRouting = {
  fallback: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.QuoteOwnerRouting';
} & { '@type'?: 'QUOTE_OWNER' };

export type RotationMethod =
  | 'RANDOM'
  | 'LEAST_BUSY'
  | 'ROUND_ROBIN'
  | unhandledEnumCase;

export const SkillBasedRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.SkillBasedRouting';
export const SkillBasedRoutingDiscriminant = 'SKILL_BASED_ROUTING';
export const SkillBasedRoutingDiscriminantKey = '@type';
export type SkillBasedRouting = {
  workflowId: number;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.SkillBasedRouting';
} & { '@type'?: 'SKILL_BASED_ROUTING' };

export const SkillRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.SkillRouting';
export const SkillRoutingDiscriminant = 'SKILL';
export const SkillRoutingDiscriminantKey = '@type';
export type SkillRouting = {
  skills: Default<Skill[]>;
  skillMatchMode: Default<SkillMatchMode>;
  usersAndTeamsRule?: UsersAndTeamsRouting;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.SkillRouting';
} & { '@type'?: 'SKILL' };

export const SpecifiedHoursRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.SpecifiedHoursRouting';
export const SpecifiedHoursRoutingDiscriminant = 'SPECIFIED_HOURS';
export const SpecifiedHoursRoutingDiscriminantKey = '@type';
export type SpecifiedHoursRouting = {
  timezoneId: string;
  hoursByRule: Default<RuleWithHours[]>;
  defaultRule: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.SpecifiedHoursRouting';
} & { '@type'?: 'SPECIFIED_HOURS' };

export const TeamsOnlyRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.TeamsOnlyRouting';
export const TeamsOnlyRoutingDiscriminant = 'TEAMS_ONLY';
export const TeamsOnlyRoutingDiscriminantKey = '@type';
export type TeamsOnlyRouting = {
  teamIds: Default<number[]>;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.TeamsOnlyRouting';
} & { '@type'?: 'TEAMS_ONLY' };

export const UnassignedRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.UnassignedRouting';
export const UnassignedRoutingDiscriminant = 'UNASSIGNED';
export const UnassignedRoutingDiscriminantKey = '@type';
export type UnassignedRouting = {
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.UnassignedRouting';
} & { '@type'?: 'UNASSIGNED' };

export const UsersAndTeamsRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.UsersAndTeamsRouting';
export const UsersAndTeamsRoutingDiscriminant = 'USERS_AND_TEAMS';
export const UsersAndTeamsRoutingDiscriminantKey = '@type';
export type UsersAndTeamsRouting = {
  userIds: Default<number[]>;
  teamIds: Default<number[]>;
  fallback?: RoutingRuleDefinition;
  fallbackV2?: RoutingRuleDefinition;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.UsersAndTeamsRouting';
} & { '@type'?: 'USERS_AND_TEAMS' };

export const WaitlistRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.WaitlistRouting';
export const WaitlistRoutingDiscriminant = 'WAITLIST';
export const WaitlistRoutingDiscriminantKey = '@type';
export type WaitlistRouting = {
  waitlistRoutingTargets: WaitlistRoutingTargets;
  distribution: Default<Distribution>;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  __typename: 'com.hubspot.cv.assignments.core.routing.WaitlistRouting';
} & { '@type'?: 'WAITLIST' };

export const WorkflowRoutingTypename =
  'com.hubspot.cv.assignments.core.routing.WorkflowRouting';
export const WorkflowRoutingDiscriminant = 'WORKFLOW_ROUTING';
export const WorkflowRoutingDiscriminantKey = '@type';
export type WorkflowRouting = {
  workflowId: number;
  shouldFilterToAvailable: Default<boolean>;
  rotationMethod: Default<RotationMethod>;
  distribution: Default<Distribution>;
  __typename: 'com.hubspot.cv.assignments.core.routing.WorkflowRouting';
} & { '@type'?: 'WORKFLOW_ROUTING' };

export type DeploymentTarget = {
  includedSegmentIds: Default<number[]>;
  excludedSegmentIds: Default<number[]>;
};

export type Skill = { category: string; categoryLabel?: string; value: string };

export type SkillMatchMode = 'ALL' | 'ANY' | unhandledEnumCase;

export type WaitlistRoutingTargets = {
  teamIds: Default<number[]>;
  userIds: Default<number[]>;
  skillValues: Default<string[]>;
  skills: Default<Skill[]>;
  routingRuleDefinition: RoutingRuleDefinition;
  workflowId?: number;
  actionId?: number;
};

export type RuleWithHours = {
  rule: RoutingRuleDefinition;
  hours: Default<OfficeHours[]>;
};

export type DeletedFilter = 'ALL' | 'NON_DELETED_ONLY' | unhandledEnumCase;

export type AgentType = 'SUPPORT' | 'QUALIFICATION' | unhandledEnumCase;

export type OpenAiRealtimeVoice =
  | 'ALLOY'
  | 'ASH'
  | 'BALLAD'
  | 'CORAL'
  | 'ECHO'
  | 'FABLE'
  | 'ONYX'
  | 'NOVA'
  | 'SAGE'
  | 'SHIMMER'
  | 'VERSE'
  | unhandledEnumCase;

export type IsMaintenanceModeEnabledResponseType =
  IsMaintenanceModeEnabledResponse;
export type IsMaintenanceModeEnabledErrorType = AiAgentError & HubspotMetadata;
export const isMaintenanceModeEnabledRpc: ChirpAvroRpcDetails<
  undefined,
  IsMaintenanceModeEnabledResponseType,
  IsMaintenanceModeEnabledErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'isMaintenanceModeEnabled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABWDoMUAiQ5eD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ValidateNameRequestType = Requestify<ValidateAgentNameRequest>;
export type ValidateNameResponseType = ValidateAgentNameResponse;
export type ValidateNameErrorType = AiAgentError & HubspotMetadata;
export const validateNameRpc: ChirpAvroRpcDetails<
  ValidateNameRequestType,
  ValidateNameResponseType,
  ValidateNameErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'validateName',
  auth: 'app',
  fingerprint: '1I0T3C00mCGWSjOJghODtD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateAgentRequestType = Requestify<AiAgentCreateRequest>;
export type CreateAgentResponseType = AiAgentIdResponse;
export type CreateAgentErrorType = AiAgentError & HubspotMetadata;
export const createAgentRpc: ChirpAvroRpcDetails<
  CreateAgentRequestType,
  CreateAgentResponseType,
  CreateAgentErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'createAgent',
  auth: 'app',
  fingerprint: 'LD6UPinJXeS72TD1DPm2tz4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAgentProfileRequestType =
  Requestify<AiAgentUpdateProfileRequest>;
export type UpdateAgentProfileResponseType = AiAgentProfileResponse;
export type UpdateAgentProfileErrorType = AiAgentError & HubspotMetadata;
export const updateAgentProfileRpc: ChirpAvroRpcDetails<
  UpdateAgentProfileRequestType,
  UpdateAgentProfileResponseType,
  UpdateAgentProfileErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'updateAgentProfile',
  auth: 'app',
  fingerprint: 'yndjrFiopC083H-Sc2l41T4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentProfileByUserIdRequestType = Requestify<GetAiAgentRequest>;
export type GetAgentProfileByUserIdResponseType = AiAgentProfileResponse;
export type GetAgentProfileByUserIdErrorType = AiAgentError & HubspotMetadata;
export const getAgentProfileByUserIdRpc: ChirpAvroRpcDetails<
  GetAgentProfileByUserIdRequestType,
  GetAgentProfileByUserIdResponseType,
  GetAgentProfileByUserIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentProfileByUserId',
  auth: 'app',
  fingerprint: '8Z26s-MkmGI83H-Sc2l41T4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentByUserIdRequestType = Requestify<GetAiAgentRequest>;
export type GetAgentByUserIdResponseType = GetAiAgentByUserIdResponse;
export type GetAgentByUserIdErrorType = AiAgentError & HubspotMetadata;
export const getAgentByUserIdRpc: ChirpAvroRpcDetails<
  GetAgentByUserIdRequestType,
  GetAgentByUserIdResponseType,
  GetAgentByUserIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentByUserId',
  auth: 'app',
  fingerprint: '8Z26s-MkmGLh3M1jA5bpSD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAgentToneRequestType = Requestify<GetAiAgentRequest>;
export type GetAgentToneResponseType = AgentToneResponse;
export type GetAgentToneErrorType = AiAgentError & HubspotMetadata;
export const getAgentToneRpc: ChirpAvroRpcDetails<
  GetAgentToneRequestType,
  GetAgentToneResponseType,
  GetAgentToneErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAgentTone',
  auth: 'app',
  fingerprint: '8Z26s-MkmGL3JVqFpkFWqz4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAiAgentOrThrowIfMultipleResponseType =
  GetAiAgentOrThrowIfMultipleResponse;
export type GetAiAgentOrThrowIfMultipleErrorType = AiAgentError &
  HubspotMetadata;
export const getAiAgentOrThrowIfMultipleRpc: ChirpAvroRpcDetails<
  undefined,
  GetAiAgentOrThrowIfMultipleResponseType,
  GetAiAgentOrThrowIfMultipleErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentOrThrowIfMultiple',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADmIF-fnkT5RT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAiAgentsForPortalRequestType =
  Requestify<AiAgentPortalPagedRequest>;
export type GetAiAgentsForPortalResponseType = AiAgentPortalPagedResponse;
export type GetAiAgentsForPortalErrorType = AiAgentError & HubspotMetadata;
export const getAiAgentsForPortalRpc: ChirpAvroRpcDetails<
  GetAiAgentsForPortalRequestType,
  GetAiAgentsForPortalResponseType,
  GetAiAgentsForPortalErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentsForPortal',
  auth: 'app',
  fingerprint: 'LP3IbM57wEhtBqZwu13etz4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAiAgentProfilesForPortalRequestType =
  Requestify<AiAgentProfilePortalPagedRequest>;
export type GetAiAgentProfilesForPortalResponseType =
  AiAgentProfilePortalPagedResponse;
export type GetAiAgentProfilesForPortalErrorType = AiAgentError &
  HubspotMetadata;
export const getAiAgentProfilesForPortalRpc: ChirpAvroRpcDetails<
  GetAiAgentProfilesForPortalRequestType,
  GetAiAgentProfilesForPortalResponseType,
  GetAiAgentProfilesForPortalErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getAiAgentProfilesForPortal',
  auth: 'app',
  fingerprint: 'gH6-2YSBO0Qb1HPjwh1WID4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetHydratedAiAgentDataForPortalResponseType =
  AiAgentHydratedResponse;
export type GetHydratedAiAgentDataForPortalErrorType = AiAgentError &
  HubspotMetadata;
export const getHydratedAiAgentDataForPortalRpc: ChirpAvroRpcDetails<
  undefined,
  GetHydratedAiAgentDataForPortalResponseType,
  GetHydratedAiAgentDataForPortalErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getHydratedAiAgentDataForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABhPQ3HZfK3LD4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetHydratedAiAgentDataForPortalV2ResponseType =
  AiAgentHydratedResponseV2;
export type GetHydratedAiAgentDataForPortalV2ErrorType = AiAgentError &
  HubspotMetadata;
export const getHydratedAiAgentDataForPortalV2Rpc: ChirpAvroRpcDetails<
  undefined,
  GetHydratedAiAgentDataForPortalV2ResponseType,
  GetHydratedAiAgentDataForPortalV2ErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'getHydratedAiAgentDataForPortalV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAyHS124h4gzT4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteAgentRequestType = Requestify<DeleteAiAgentRequest>;
export type DeleteAgentResponseType = VoidResponse;
export type DeleteAgentErrorType = AiAgentError & HubspotMetadata;
export const deleteAgentRpc: ChirpAvroRpcDetails<
  DeleteAgentRequestType,
  DeleteAgentResponseType,
  DeleteAgentErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'deleteAgent',
  auth: 'app',
  fingerprint: 'BUX2FggQmPiOQ99dyMYnND4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RestoreAgentRequestType = Requestify<RestoreAiAgentRequest>;
export type RestoreAgentResponseType = VoidResponse;
export type RestoreAgentErrorType = AiAgentError & HubspotMetadata;
export const restoreAgentRpc: ChirpAvroRpcDetails<
  RestoreAgentRequestType,
  RestoreAgentResponseType,
  RestoreAgentErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.ai.agents.configuration.rpc.AiAgentService',
  rpcName: 'restoreAgent',
  auth: 'app',
  fingerprint: 'G5P8MAlt1iWOQ99dyMYnND4iqPXXNze1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
